import server from "./shareServer";

export default server;